var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "1 1 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 26,
    height: 26,
    rx: 13,
    fill: "#3862F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8561 15.4965C20.8561 14.8895 20.3641 14.3985 19.7582 14.3985H19.4442V14.3895C20.0512 14.3895 20.5421 13.8975 20.5421 13.2916C20.5421 12.6856 20.0502 12.1936 19.4442 12.1936V12.1866L15.0754 12.2416C15.9193 10.7607 15.9123 9.08374 15.7953 8.06078C15.7333 7.5158 15.2754 7.10382 14.7264 7.10382C14.1774 7.10382 13.7344 7.5048 13.6594 8.03778C13.4184 9.79571 12.5855 10.5197 11.8305 11.5936C10.9555 12.8336 10.8735 14.2635 10.8735 14.2635V18.1474C10.8735 19.2253 11.7485 20.1023 12.8285 20.1023H19.4462C19.8712 20.1023 20.2171 19.7573 20.2171 19.3313C20.2171 18.9053 19.8722 18.5603 19.4462 18.5603C19.9862 18.5603 20.4251 18.1224 20.4251 17.5814C20.4251 17.0404 19.9872 16.6024 19.4462 16.6024V16.5934H19.7602L19.7582 16.5914C20.3651 16.5914 20.8561 16.0994 20.8561 15.4935V15.4965Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.79651 13.9907H9.58644C9.74443 13.9907 9.87342 14.1197 9.87342 14.2777V19.3715C9.87342 19.5295 9.74443 19.6585 9.58644 19.6585H7.79651C7.63852 19.6585 7.50952 19.5295 7.50952 19.3715V14.2777C7.50952 14.1197 7.63852 13.9907 7.79651 13.9907Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/Like.03940703.svg";
export { ForwardRef as ReactComponent };